import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { DepositMainLabels } from "../cashier-models/interfaces";
import { DepositMainModel } from "../cashier-models/models";

@Component({
  selector: "page-deposit-e-check-add",
  templateUrl: "deposit-e-check-add.html",
})
export class DepositECheckAddPage extends CashierBase implements OnInit {
  @ViewChild('Content') content: IonContent;

    private error = null;
    private addAccountForm: FormGroup;
    @Input() amount: string;
    @Input() bonusCode: string;
    @Input() bonusID: string;
    private transitNumber: AbstractControl;
    private institutionNumber: AbstractControl;
    private accountNumber: AbstractControl;
    private accountType: AbstractControl;
    private bankName: AbstractControl;
    private payment_type_code: AbstractControl;
    
    private accounts: any = [];
    public buttonDisabled: boolean = false;
    @Input() ssnValue;
    public ssnValueFormatted;
    public labels: DepositMainLabels;
    @Input() navigateBackPage: string;

    constructor(
        // protected logger: Logger,
        protected cashierProvider: CashierService,
        // protected mainProvider: MainProvider,
        protected events: EventsService,
        protected successMessageService: SuccessMessageService,
        protected utilsService: UtilsService,
        public cashierContentService: CashierContentService,
        private navigator:Navigator
    ) {
        
        super();
        this.labels = new DepositMainModel();
        this.successMessageService.clearMessage();
        this.error = null;
    }
    ngAfterViewInit() {
        this.cashierContentService.getPageConfig('echeck-add').then((response: DepositMainLabels) => {
          this.labels = response;
        });
      }
    ngOnInit() {
        this.addAccountForm = new FormGroup(
            {
                transitNumber: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^[0-9]*')]),
                institutionNumber: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(3), Validators.pattern('^[0-9]*')]),
                accountNumber: new FormControl('', [Validators.required, Validators.maxLength(12), Validators.pattern('^[0-9]*')]),
                ssn: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[0-9]*')]),
                accountType: new FormControl('PC', Validators.required),
                bankName: new FormControl(''),
            }
        )

        this.transitNumber = this.addAccountForm.get('transitNumber');
        this.institutionNumber = this.addAccountForm.get('institutionNumber');
        this.accountNumber = this.addAccountForm.get('accountNumber');
        this.accountType = this.addAccountForm.get('accountType');
        this.bankName = this.addAccountForm.get('bankName');

        // if (typeof this.ssnValue != 'undefined') {
        //     this.ssnValueFormatted = this.utils.formatssnValue(this.ssnValue);
        //     this.addAccountForm.controls['ssn'].clearValidators();
        // }
    }
    ionViewDidLoad() {
        console.log('ionViewDidLoad DepositECheckAddPage');
       
    }

    onAddAccount() {
        this.buttonDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;
        
        let addAccountFormObj: any = this.addAccountForm.value;

        addAccountFormObj.payment_type_code = "ACH";
      
        if (typeof this.ssnValue != 'undefined') {
            addAccountFormObj.ssn = this.ssnValue;
        }
      
        this.cashierProvider.callAddAccount(addAccountFormObj).subscribe(
            (response: any) => {
                if (response && !!response.result ) {

                    if (response.payload != null) {
                        this.onDeposit(response.payload.customerAccountID);
                    }
                }
            },
            (error) => {
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("onAddAccount error = ", error);

                this.content.scrollToTop();
            }
        )

        this.error = null;
    }

    onDeposit(customerAccountID: string) {
        this.buttonDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;

        let depositFormObj: any = {};
        
        if (this.bonusCode != "") {
            depositFormObj.bonusCode = this.bonusCode;
        }
        if (this.bonusID != "") {
            depositFormObj.bonusID = this.bonusID;
        }

        depositFormObj.amount = this.amount;
        depositFormObj.customerAccountID = customerAccountID;
        depositFormObj.currency_code = this.cashierProvider.customer.preferredCurrency.currencyCode;
        depositFormObj.payment_type_code = "ACH";
        
        this.cashierProvider.callDeposit(depositFormObj).subscribe(
            (response: any) => {
                if (response && !!response.result ) {
                    /*let depositEventData = {
                        customerId: this.cashierProvider.customer.customerId,
                        amount: depositFormObj.amount,
                        transaction_id: response.payload.paymentRequestID,
                        paymentMethod: "ACH",
                        bonusCode: depositFormObj.bonusCode,
                        bonusID: depositFormObj.bonusID
                    }
                    setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
                    this.navigator.navigateTo("DepositSuccessfulPage", {multipleModals: false}, {amount: this.amount});
                }
                this.buttonDisabled = false;
            },
            (error) => {
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("onSubmit error = ", error);
                this.buttonDisabled = false;
                this.content.scrollToTop();
            }
        )

        this.error = null;
    }

    hasSin() {
        if (typeof this.ssnValue != 'undefined' && this.ssnValue != '') {
            return true;
        }
        return false;
    }

    onBack = () => {
        if (!!this.navigateBackPage) {
            if(this.navigateBackPage == "default"){
              this.navigator.navigateTo("CashierMainPage", { multipleModals: true });
            }else{
              this.navigator.navigateTo(this.navigateBackPage);
            }
          } else {
              this.navigator.back();
          }
    }
}
